export const filterIcons = [
  {
    key: 1,
    icon: (
      <img alt="icon" src="/icons/right_to_left.svg" className="svg-icons" />
    ),
    englishName: "right to left [RL]",
    arabicName: "من اليمين الى اليسار",
  },
  {
    key: 2,
    icon: (
      <img alt="icon" src="/icons/left_to_right.svg" className="svg-icons" />
    ),
    englishName: "left to right [LR]",
    arabicName: "من اليسار إلى اليمين",
  },
  {
    key: 3,
    icon: <img alt="icon" src="/icons/both_RL_LR.svg" className="svg-icons" />,
    englishName: "both [RLLR]",
    arabicName: "من الجهتين",
  },
  {
    key: 4,
    icon: <img alt="icon" src="/icons/vertical.svg" className="svg-icons" />,
    englishName: "vertical",
    arabicName: "عمودي",
  },
  {
    key: 5,
    icon: <img alt="icon" src="/icons/mixed.svg" className="svg-icons" />,
    englishName: "mixed",
    arabicName: "مختلط",
  },
  {
    key: 6,
    icon: <img alt="icon" src="/icons/separate.svg" className="svg-icons" />,
    englishName: "separate",
    arabicName: "متفرق",
  },
  {
    key: 7,
    icon: (
      <img alt="icon" src="/icons/flip_vertical.svg" className="svg-icons" />
    ),
    englishName: "flip vertical",
    arabicName: "عكس عامودي",
  },
  {
    key: 8,
    icon: (
      <img alt="icon" src="/icons/flip_horizontal.svg" className="svg-icons" />
    ),
    englishName: "flip horizontal",
    arabicName: "عكس أفقي",
  },
  {
    key: 9,
    icon: <img alt="icon" src="/icons/donot_flip.svg" className="svg-icons" />,
    englishName: "do not flip",
    arabicName: "لا إنعكاس",
  },
  {
    key: 10,
    icon: <img alt="icon" src="/icons/parallel.svg" className="svg-icons" />,
    englishName: "parallel text",
    arabicName: "نصوص متوازية",
  },
  {
    key: 11,
    icon: <img alt="icon" src="/icons/cross.svg" className="svg-icons" />,
    englishName: "cross text",
    arabicName: "نصوص عابرة",
  },
  {
    key: 12,
    icon: <img alt="icon" src="/icons/rotate_90.svg" className="svg-icons" />,
    englishName: "rotate 90",
    arabicName: "تدوير 90",
  },
  {
    key: 13,
    icon: <img alt="icon" src="/icons/rotate_180.svg" className="svg-icons" />,
    englishName: "rotate 180",
    arabicName: "تدوير 180",
  },
];

export const readingDirectionMenuData = [
  {
    key: 1,
    menuOption: "من اليمين الى اليسار%right to left [RL]",
  },
  {
    key: 2,
    menuOption: " من اليسار الى اليمين%left to right [LR]",
  },
  { key: 3, menuOption: " من الجهتين%both [RLLR]" },
  { key: 4, menuOption: "عامودي%vertical" },
];

export const scriptProximityMenuData = [
  { key: 5, menuOption: "متداخلة%mixed" },
  { key: 6, menuOption: " منفصلة%separate" },
];

export const readerAction01MenuData = [
  { key: 7, menuOption: "عكس عامودي%flip vertical" },
  { key: 8, menuOption: "عكس أفقي%flip horizontal" },
  { key: 9, menuOption: "لا إنعكاس%do not flip" },
];

export const textBehaviourMenuData = [
  { key: 10, menuOption: "نصوص متوازية%parallel text" },
  { key: 11, menuOption: " نصوص عابرة بعضها البعض%cross text" },
];

export const readerAction02MenuData = [
  { key: 12, menuOption: "تدوير 90%rotate 90" },
  { key: 13, menuOption: "تدوير 180%rotate 180" },
];
